import { Box, Fade, Grid, Modal, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Backdrop from '@mui/material/Backdrop';
import Swal from 'sweetalert2';
import Success from '../../images/undraw/undraw_completed_tasks_vs6q.svg';
import ServerDown from '../../images/undraw/undraw_server_down_s-4-lk.svg';
import ReConfirm from '../../images/undraw/undraw_confirmation_re_b6q5.svg';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import secureLocalStorage from 'react-secure-storage';
import { createMRTColumnHelper } from 'material-react-table';
import CummonTable from '../../Common/CummonTable';
import FetchLoading from './../../Loading/FetchLoading';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: '#fff',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const AdminBankAccount = () => {
  const navigate = useNavigate();
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo?.token;
  const [isloading, setIsloading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [updateBank, setUpdateBank] = useState({});
  const [editBank, setEditBank] = useState(false);
  const handleOpen = (data) => {
    setUpdateBank(data);
    setEditBank(true);
  };
  const handleClose = () => setEditBank(false);
  const [bankData, setBankData] = useState([]);
  const [allBankData, setAllBankData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [refetch, setRefetch] = useState(false);

  let size = 20;
  // Handle a page change.
  const handlePageChange = (event, value) => {
    setPage(value);
    setBankData(allBankData.slice((value - 1) * size, value * size));
  };

  const handleUpdateData = (e) => {
    setUpdateBank({
      ...updateBank,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateBank = async (e) => {
    e.preventDefault();
    setUpdating(true);

    const url = `https://api-b2b.businesssolutions.ae/admin/banklist/${updateBank?.uid}`;
    const body = JSON.stringify({
      uid: updateBank?.id,
      bankname: updateBank?.bankname,
      accountname: updateBank?.accountname,
      accountnumber: updateBank?.accountnumber,
    });
    const config = {
      method: 'PATCH',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Include the token in the header
      },
      body: body,
    };

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      setEditBank(false);
      Swal.fire({
        imageUrl: Success,
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: 'Custom image',
        title: 'Bank Details Updated!',
        confirmButtonColor: 'var(--primary-color)',
        confirmButtonText: 'Ok',
      }).then(() => {
        setUpdating(false);
        setRefetch(!refetch);
      });
    } catch (error) {
      console.error('Error updating bank details:', error);
      setEditBank(false);
      Swal.fire({
        imageUrl: ServerDown,
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: 'Custom image',
        title: error?.message,
        confirmButtonColor: 'var(--primary-color)',
        confirmButtonText: 'Try Another Time',
      }).then(() => {
        setUpdating(false);
      });
    }
  };

  const bankAccountDelete = (id) => {
    const url = `https://api-b2b.businesssolutions.ae/admin/banklist/${id}`;

    Swal.fire({
      imageUrl: ReConfirm,
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
      title: 'You want to delete Bank Details?',
      showCancelButton: true,
      confirmButtonColor: 'red',
      confirmButtonText: 'Delete',
      cancelButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancel',
    }).then((willDelete) => {
      if (willDelete.isConfirmed) {
        fetch(url, {
          method: 'DELETE',
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // Include the token in the header
          },
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            Swal.fire({
              imageUrl: Success,
              imageWidth: 400,
              imageHeight: 200,
              imageAlt: 'Custom image',
              title: 'Bank Deleted!',
              confirmButtonColor: 'var(--primary-color)',
              confirmButtonText: 'Ok',
            }).then(() => {
              setRefetch(!refetch);
            });
          })
          .catch((err) => {
            console.error('Error deleting bank details:', err);
            Swal.fire({
              imageUrl: ServerDown,
              imageWidth: 400,
              imageHeight: 200,
              imageAlt: 'Custom image',
              title: err?.message,
              confirmButtonColor: 'var(--primary-color)',
              confirmButtonText: 'Try Another Time',
            });
          });
      }
    });
  };

  useEffect(() => {
    const fetchQueuesData = () => {
      setIsloading(true);

      fetch(`https://api-b2b.businesssolutions.ae/admin/banklist/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setBankData(data);
          setAllBankData(data);
        })
        .catch((error) => console.error('Error fetching data:', error))
        .finally(() => setIsloading(false));
    };

    fetchQueuesData();
  }, [refetch]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor('bankname', {
      header: 'Bank Name',
    }),
    columnHelper.accessor('accountname', {
      header: 'Account Name',
    }),
    columnHelper.accessor('accountnumber', {
      header: 'Account Number',
    }),
    columnHelper.accessor('amount', {
      header: 'Amount',
      Cell: ({ row }) => (
        <Box>
          <EditIcon
            style={{
              color: 'var(--primary-color)',
              fontSize: '22px',
              marginRight: '10px',
              cursor: 'pointer',
            }}
            onClick={() => handleOpen(row.original)}
          />
          <DeleteIcon
            style={{
              color: 'tomato',
              fontSize: '22px',
              cursor: 'pointer',
            }}
            onClick={() => bankAccountDelete(row.original)}
          />
        </Box>
      ),
    }),
  ];

  return (
    <Box>
      <AdminHeader />

      <Box p={2}>
        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '24px',
              color: '#222222',
              fontFamily: 'poppins',
            }}
          >
            Bank Account
          </Typography>
          <Button
            style={{
              padding: '5px 10px',
              color: 'var(--white)',
              background: 'var(--secondary-color)',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '4px',
              textTransform: 'capitalize',
              fontSize: '14px',
            }}
            onClick={() => {
              navigate('/dashboard/addbank');
            }}
          >
            Add Bank
          </Button>
        </Stack>
        {!isloading ? (
          <CummonTable data={bankData} columns={columns} pageSize={15} />
        ) : (
          <FetchLoading />
        )}
      </Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={editBank}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={editBank}>
          <Box sx={style}>
            <Box mt={2}>
              <Typography
                sx={{
                  fontWeight: '500px',
                  fontSize: '23px',
                  color: '#003566',
                  textAlign: 'center',
                }}
                mb={2}
              >
                Update Account
              </Typography>

              <form onSubmit={handleUpdateBank}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={2} md={6}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Bank Name
                      </Typography>
                      <input
                        required
                        type="text"
                        name="bankname"
                        value={updateBank?.bankname || ''}
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="Bank Name"
                        onChange={handleUpdateData}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={6}>
                    <Box>
                      <Typography
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                        mb={1}
                      >
                        Account Name
                      </Typography>
                      <input
                        required
                        type="text"
                        name="accountname"
                        value={updateBank?.accountname || ''}
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="Account Name"
                        onChange={handleUpdateData}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={6}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Account Number
                      </Typography>
                      <input
                        required
                        type="text"
                        name="accountnumber"
                        value={updateBank?.accountnumber || ''}
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="Account Number"
                        onChange={handleUpdateData}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Button
                  disabled={updating ? true : false}
                  sx={{
                    background: 'var(--mateBlack)',
                    color: '#FFFFFF',
                    width: '370px',
                    mt: '4rem',
                    '&:hover': {
                      backgroundColor: 'var(--mateBlack)',
                    },
                  }}
                  type="submit"
                >
                  {updating ? 'Wait...' : 'Update Bank Account'}
                </Button>
              </form>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AdminBankAccount;
